import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";

interface EmergencyFundResults {
  employmentType: string;
  monthsNeeded: number;
  emergencyFundAmount: number;
  savingsPercentage: number;
  monthsToComplete: number;
}

export const EmergencyFundResponse = ({
  results,
}: {
  results: EmergencyFundResults;
}) => {
  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>
      <div className="grid gap-4 mb-2">
        <p className="text-center">
          Para trabalhadores da modalidade <strong>{results.employmentType}</strong> o ideal é que a reserva de emergência contemple <strong>{results.monthsNeeded} meses</strong> dos custos fixos.
        </p>
        <div className="p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            Sua Reserva de Emergência deve ser de
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            <span className="text-sm mr-1 text-white">R$</span>
            {normalSanatizerBRL(results.emergencyFundAmount)}
          </p>
        </div>
        <div className="p-3 bg-white rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Guardando {results.savingsPercentage}% do seu salário
          </h2>
          <p className="sm:text-lg text-center font-black text-md text-red-800 m-0">
            Meses para completar sua reserva: {results.monthsToComplete}
          </p>
        </div>
      </div>
    </MainCard>
  );
};
